import React from "react";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import { useTranslation } from "react-i18next";
import RestaurantOffer from "../../components/menu/RestaurantOffer/RestaurantOffer";
import { Helmet } from "react-helmet-async";

import heroImage1 from "../../assets/images/catering/catering2.jpg";
import heroImage2 from "../../assets/images/catering/catering3.jpg";
import heroImage3 from "../../assets/images/catering/catering4.jpg";
import heroImage4 from "../../assets/images/catering/catering5.jpg";
import heroImage5 from "../../assets/images/catering/catering6.jpg";

export default function Menu() {
  const { t } = useTranslation(["menu", "links"]);
  return (
    <Layout>
      <Helmet>
        <title>Otkrijte naš ukusni meni</title>
        <meta
          name="description"
          content={
            "Od domaćih specijaliteta do gurmanskih poslastica, naš meni je osmišljen da zadovolji svačiji ukus. Bilo da želite lagani obrok ili kompletan ručak, imamo ponudu za vas."
          }
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs/menu"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Otkrijte naš ukusni meni"} />
        <meta
          property="og:description"
          content={
            "Od domaćih specijaliteta do gurmanskih poslastica, naš meni je osmišljen da zadovolji svačiji ukus. Bilo da želite lagani obrok ili kompletan ručak, imamo ponudu za vas."
          }
        />
        <meta property="og:image" content={heroImage1} />
        <meta property="og:url" content={"https://vidovdanrestoran.rs/menu"} />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Otkrijte naš ukusni meni"} />
        <meta
          name="twitter:description"
          content={
            "Od domaćih specijaliteta do gurmanskih poslastica, naš meni je osmišljen da zadovolji svačiji ukus. Bilo da želite lagani obrok ili kompletan ručak, imamo ponudu za vas."
          }
        />
        <meta name="twitter:image" content={heroImage1} />
      </Helmet>
      <HeroSection
        title={t("menu_hero_title")}
        subTitle={t("menu_hero_subtitle")}
        description={t("menu_hero_description")}
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
      />
      <RestaurantOffer t={t} />
    </Layout>
  );
}
